import { gql } from '@/Types/gql';

export const GET_ALL_SUBSCRIPTIONS = gql(`
    query GetAllPurchase($search: String, $filter: JSON, $limit: Int, $sort: JSON, $offset: Int) {
    getAllPurchase(search: $search, filter: $filter, limit: $limit, sort: $sort, offset: $offset) {
        _id
        paymentDate
        transactionId
        sessionSubscribed
        paymentMethod
        programDetails{
            programName
            
        }
        paymentMode
        amount
        sessionCount
        localizedPrice
        currencyType
    }
    getAllPurchaseCount(search: $search, filter: $filter)
    }
`);

export const GET_ALL_PLANS = gql(`
query GetAllPlan($filter: JSON, $sort: JSON) {
    getAllPlan(filter: $filter, sort: $sort) {
      recommendedNoOfDays
      originalPrice
      price
      sessionCount
      planName
        _id
      program {
        programName
        description
      }
      product_id
      promoCodeEnabled
    }
}`);

export const GET_MY_SAVED_CARD = gql(`
    query GetMySavedCards {
    getMySavedCards {
        stripeCustomerId
        cards {
        brand
        expMonth
        expYear
        last4
        }
    }
    }
`);

export const VALIDATE_PROMOTION_CODE = gql(`
query ValidatePromotionCode($code: String!, $planId: ID!) {
  validatePromotionCode(code: $code, planId: $planId) {
    valid
    message
    discount {
      promotionCode
      percentOff
      originalAmount
      discountAmount
      finalAmount
    }
  }
}
`);
